module.exports = __webpack_public_path__ + "img/company_logo.064fffb9.png";